module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.02,"color":"#198CDB","label":"<=2"},{"quantity":0.03,"color":"#91E3AD","label":"2-3"},{"quantity":0.04,"color":"#DEFFB0","label":"3-4"},{"quantity":0.05,"color":"#FFE68C","label":"4-5"},{"quantity":0.07,"color":"#FF9982","label":"5-7"},{"quantity":0.7,"color":"#FF4D30","label":">7"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_100_wheat.json
// module id = 8z3A
// module chunks = 171